import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedTableComponent } from '@tamilarasitech/shared-ui-components';
@Component({
  selector: 'app-corporates',
  standalone: true,
  imports: [CommonModule, SharedTableComponent],
  template: `<tt-shared-table
    name="corporates"
  ></tt-shared-table>`,
})
export class CorporatesComponent {}